import { createApp, h } from 'vue'
import store from '@/store'
import Login from '@/pages/login/Login.vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

const { bugsnagApiKey, onError } = require('@/utils/bugsnag.ts')
Bugsnag.start({
    apiKey: bugsnagApiKey,
    plugins: [new BugsnagPluginVue()],
    onError,
})
const bugsnagVuePlugin = Bugsnag.getPlugin('vue')

document.addEventListener('DOMContentLoaded', () => {
    const id = 'login'
    const el = document.getElementById(id)

    if (el) {
        const app = createApp({
            render: () => h(Login),
        })
        app.use(store)
        if (bugsnagVuePlugin) {
            app.use(bugsnagVuePlugin)
        }
        app.mount('#' + id)
    }
})
